import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_coach/library/workouts")({
  component: RouteComponent,
  staticData: {
    getBreadcrumb: () => {
      return {
        href: "/library/workouts",
        labelTranslationKey: "workoutsPage.breadcrumb",
      };
    },
  },
});

function RouteComponent() {
  return <Outlet />;
}
